<template>
    <div class="contact-block" @click="($event) => $emit('click', $event)">
        <div class="box d-flex">
            <img v-if="model.picture" :src="model.picture" aria-hidden="true" />
            <div class="contact-info">
                <p v-if="model.name" class="mb-1 mt-2 name">
                    <b>{{ model.name }}</b>
                </p>
                <p v-if="model.title" class="mb-2">
                    <b>{{ model.title }}</b>
                </p>
                <p v-if="model.jobDescription" v-html="model.jobDescription"></p>
                <p v-if="model.contactTitle" class="mb-1">
                    <b>{{ model.contactTitle }}</b>
                </p>
                <p v-if="model.email" class="mb-0">
                    <a :href="`mailto:${model.email}`">{{ model.email }}</a>
                </p>
                <p v-if="model.phone" class="mb-2">
                    <a :href="`tel:${model.phone}`">{{ model.phone }}</a>
                </p>
                 <p v-if="showAssistantTitle()" class="mb-1">
                    <b>{{ model.assistantTitle }}</b>
                </p>
                <p v-if="model.assistantEmail" class="mb-0">
                    <a :href="`mailto:${model.assistantEmail}`">{{ model.assistantEmail }}</a>
                </p>
                <p v-if="model.assistantPhone" class="mb-2">
                    <a :href="`tel:${model.assistantPhone}`">{{ model.assistantPhone }}</a>
                </p>
                <p v-if="model.addressLine1" class="mb-0">
                    {{ model.addressLine1 }}
                </p>
                <p class="mb-1">
                    {{ model.addressLine2 }}<span v-if="model.addressLine2 && (model.addressCity || model.addressPostalCode)">, </span>{{ model.addressPostalCode }} {{ model.addressCity }}
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            model: {
                type: Object,
                required: true
            }
        },
        methods: {
          showAssistantTitle() {
            if(this.model.showAssistantTitle != null && this.model.assistanPhone != null || this.model.assistanEmail) {
              return true;
            }
            return false;
          }
        }
    }
</script>